import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Licitações — fila de leitura dos editais classificados pelo Argos.
 *
 * Duas rotas, dois níveis (migrations 194/345), ambas FECHADAS por padrão
 * (`requires_admin_master = 1`: só o admin master vê sem concessão; os demais
 * recebem o nível em /permissions). Com concessão, `/licitacoes` é `member`
 * (lê e comenta; `editor` registra a decisão comercial) e `/licitacoes/operacao`
 * é `admin` — de lá se dispara lote e reprocessamento, que consomem dias de GPU
 * compartilhada. São rotas SEPARADAS de propósito: herdar a permissão da fila
 * daria o painel de operação a todo mundo que lê a lista — e por isso a tela da
 * fila consulta `/licitacoes/operacao` (não a própria rota) antes de mostrar a
 * entrada do painel.
 */
export const licitacoesRoutes: RouteRecordRaw[] = [
  {
    path: '/licitacoes',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Licitações' },
    children: [
      {
        path: '',
        name: 'Licitacoes',
        component: () => import('@/views/Licitacoes/LicitacoesPage.vue'),
        meta: { requiresAuth: true, title: 'Licitações', breadcrumb: 'Licitações' },
      },
      {
        path: 'operacao',
        name: 'LicitacoesOperacao',
        component: () => import('@/views/Licitacoes/admin/LicitacoesOperacao.vue'),
        meta: {
          requiresAuth: true,
          title: 'Licitações · Operação',
          breadcrumb: 'Licitações / Operação',
        },
      },
    ],
  },
];

export default licitacoesRoutes;
